import { createRouter, createWebHistory } from 'vue-router';
import { useUserStore } from '@/store/index';
import HomePage from '../views/HomePage.vue';
import LoginPage from '../views/LoginPage.vue';
import SetMenuPage from '../views/menu/SetMenuPage.vue';
import UserDeptPage from '../views/dept/UserDeptPage.vue';
import UserPromPage from '../views/prom/UserPromPage.vue';
import UserPage from '../views/user/UserPage.vue';
import TenantPage from '../views/tenant/TenantPage.vue';
import ErrorPage from '@/views/ErrorPage.vue';
import AuthLayout from '@/layouts/AuthLayout.vue';
import AdminLayout from '@/layouts/AdminLayout.vue';
import UserLayout from '@/layouts/UserLayout.vue';
import AnnouncePage from "@/views/announce/AnnouncePage.vue";
import SetPage from "@/views/set/SetPage.vue";
import LogPage from "@/views/log/LogPage.vue";
import BizHomePage from "@/views/biz_home/BizHomePage.vue";
import TaxCasePage from "@/views/service_taxcase/TaxCasePage.vue";
import FollowQuestionPage from "@/views/service_follow_question/FollowQuestionPage.vue";
import CodePage from "@/views/service_code/CodePage.vue";
import FaqPage from "@/views/service_faq/FaqPage.vue";
import CommodityPage from "@/views/commodity/CommodityPage.vue";
import PayRecordPage from "@/views/pay/PayRecordPage.vue";
import BackNoticePage from "@/views/pay/BackNoticePage.vue";


const routes = [
    {
        path: '/',
        component: AuthLayout,
        children: [
            {
                path: '',
                redirect: '/login',
            },
            {
                path: 'login',
                name: 'SYS_LOGIN',
                component: LoginPage,
            },
            {
                path: 'error',
                name: 'SYS_ERROR',
                component: ErrorPage,
            }
        ]
    },
    {
        path: '/',
        component: AdminLayout,
        children: [
            {
                path: '',
                redirect: '/home',
            },
            {
                path: 'home',
                name: 'SYS_HOME',
                component: HomePage,
            },
            {
                path: 'menu',
                name: 'SET_MENU',
                component: SetMenuPage,
            },
            {
                path: 'dept',
                name: 'USER_DEPT',
                component: UserDeptPage,
            },
            {
                path: 'pms',
                name: 'USER_PMS',
                component: UserPromPage,
            },
            {
                path: 'user',
                name: 'USER_MANAGER',
                component: UserPage,
            },
            {
                path: 'ten',
                name: 'SET_TEN',
                component: TenantPage,
            },{
                path: 'ann',
                name: 'USER_ANNOUNCE',
                component: AnnouncePage,
            },{
                path: 'set',
                name: 'SET_INFO',
                component: SetPage,
            },{
                path: 'log',
                name: 'SET_LOG',
                component: LogPage,
            },{
                path: 'agent',
                name: 'TAX_CASE',
                component: TaxCasePage,
            },{
                path: 'question',
                name: 'FOLLOW_QUESTION',
                component: FollowQuestionPage,
            },{
                path: 'code',
                name: 'CODE_MANAGER',
                component: CodePage,
            },{
                path: 'faq',
                name: 'FAQ_TEST',
                component: FaqPage,
            },{
                path: 'commodity',
                name: 'COMMODITY_MANAGER',
                component: CommodityPage,
            },{
                // 支付（父菜单，无独立页面，默认进入订单记录）
                path: 'pay',
                redirect: '/payrecord',
            },{
                path: 'payrecord',
                name: 'PAY_RECORD',
                component: PayRecordPage,
            },{
                path: 'backnotice',
                name: 'BACK_NOTICE',
                component: BackNoticePage,
            }
        ]
    },
    {
        path: '/app',
        component: UserLayout,
        children: [
            {
                path: '',
                name: 'BIZ_HOME',
                component: BizHomePage,
            }
        ]
    }

];

const router = createRouter({
    history: createWebHistory(),
    routes,
});



router.beforeEach((to) => {
    const token = localStorage.getItem('token');
    if (to.name !== 'SYS_LOGIN' && !token) {
        return { name: 'SYS_LOGIN' }
    }

    if (!token) return;

    // token 有效时从 store 取用户权限信息
    const userStore = useUserStore();
    const isBiz = userStore.isBizUser;

    // 业务用户（COMMON）不能访问管理后台
    if (isBiz && !to.path.startsWith('/app')) {
        return { path: '/app' };
    }

    // 管理用户不能访问业务页面
    if (!isBiz && to.path.startsWith('/app')) {
        return { path: '/home' };
    }

    // 管理用户：不在此处检查菜单权限，侧边栏已控制菜单显示
    // 只需保留业务/管理的路径隔离
});
export default router;
